module.exports = __webpack_public_path__ + "static/home_post_photo-094d13597003604c26ee4b19fb61e478.jpg";